import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";

export const validatePhoneNumber = async (
  phoneNumber: string,
  countryCode: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.post(
    M3_API().UTILS_VALIDATE_PHONE_NUMBER,
    { phoneNumber, countryCode },
    {
      headers: {
        Prefer: "code=200, example=default",
      },
    }
  );
};
